export const carouselImages = [
    {
        "imagen": "/assets/imgs/hgoLogPrincipal.png"
    },
    {
        "imagen": "/assets/imgs/transp2026.jpg"
    },
    {
        "imagen": "/assets/imgs/hgoLogPrincipal.png"
    },
    {
        "imagen": "/assets/imgs/elchico2.jpg"
    },
    {
        "imagen": "/assets/imgs/PrismasBasalticos.jpg"
    },
    {
        "imagen": "/assets/imgs/logoVino.png"
    },
    {
        "imagen": "/assets/imgs/elchico.jpg"
    },
    {
        "imagen": "/assets/imgs/RealdelMonte.jpg"
    },
    {
        "imagen": "/assets/imgs/AcueductoPadreTembleque.jpg"
    },
    {
        "imagen": "/assets/imgs/Tecozautla.jpg"
    }
]